import type { PropsWithChildren } from 'react';
import MarqueeWrapper from 'react-fast-marquee';
export const Marquee = ({
  children,
  speed = 80,
  pauseOnHover = true,
  ...rest
}: PropsWithChildren<any>) => {
  return <MarqueeWrapper gradient={false} loop={0} pauseOnHover={pauseOnHover} speed={speed} {...rest} data-sentry-element="MarqueeWrapper" data-sentry-component="Marquee" data-sentry-source-file="index.tsx">
            {children}
        </MarqueeWrapper>;
};